import React from 'react'
import { useOutletContext } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import { ReactComponent as CallIcon } from '../../assets/images/common/icons/call-icon.svg'
import { ReactComponent as MailIcon } from '../../assets/images/common/icons/mail-icon.svg'

import Loader from '../common/loader/Loader'
import classes from './FamilyContactPage.module.scss'

import ProfileAvatar from '../common/avatar/ProfileAvatar'
import { GENDER_LABEL_KEYS } from '../../utility/userHelper'
import { formatPhoneForLinks } from '../../utility/phoneHelper'

const FamilyAdminCard = ({ familyAdmin }) => {
  const { t } = useTranslation()
  const genderInitial = t(GENDER_LABEL_KEYS[familyAdmin.gender]).at(0)

  return (
    <div className={classes.familyAdminCard}>
      <h6 className='font-weight-bold'>{t('members.contactFamilyAdmin')}</h6>
      <div className={classes.profile}>
        <ProfileAvatar student={familyAdmin} />
        <div className={classes.info}>
          <div className={classes.name}>
            <span>{familyAdmin.firstName} {familyAdmin.lastName}</span>
            <span className={classes.familyAdminLabel}>{t('members.familyAdmin')}</span>
          </div>
          <span>
            {t('members.ageGenderLabel', { age: familyAdmin.age ?? '-', gender: genderInitial })}
          </span>
        </div>
      </div>
      <div className={classes.contactButtons}>
        {familyAdmin.phonePrefix && familyAdmin.phone && (
          <span>
            {familyAdmin.phonePrefix} {familyAdmin.phone || ''}
            <a href={familyAdmin.phone ? `tel:${formatPhoneForLinks(familyAdmin.phonePrefix, familyAdmin.phone)}` : '#'}>
              <CallIcon className={classes.contactIcon} />
            </a>
          </span>
        )}
        <span>
          {familyAdmin.email || '-'}
          <a href={familyAdmin.email ? `mailto:${familyAdmin.email}` : '#'}>
            <MailIcon className={classes.contactIcon} />
          </a>
        </span>
      </div>
    </div>
  )
}

FamilyAdminCard.propTypes = {
  familyAdmin: PropTypes.object.isRequired,
}

const FamilyContactPage = () => {
  const { t } = useTranslation()
  const { family } = useOutletContext()

  if (!family?.familyAdmins) {
    return (
      <div className='h-100 d-flex align-items-center justify-content-center'>
        <Loader>{t('members.loading.familyEnrollments')}</Loader>
      </div>
    )
  }

  return (
    <main className={classes.wrapper}>
      <main>
        {family.familyAdmins.map(familyAdmin => <FamilyAdminCard key={familyAdmin.id} familyAdmin={familyAdmin} />)}
      </main>
    </main>
  )
}

export default FamilyContactPage
